import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';

@Component({
	selector: 'office-icon',
	templateUrl: './icon.component.html',
})
export class OfficeIconComponent {
	@Input() name: string;
	@Input() size = '24';
	@Input() color: string;
}

@NgModule({
	imports: [CommonModule],
	declarations: [OfficeIconComponent],
	exports: [OfficeIconComponent],
})
export class OfficeIconModule {}
